export default __webpack_public_path__ + "static/media/Vector-4.cc9138c8.svg";